module.exports = __webpack_public_path__ + "media/application/images/2023/03_still-1250x703-6b3daef0816fa9a86cf4b3d3edf34ba5.png";